<template>
  <div class="grid">
    <div v-if="data.StartFrom">
      <label>{{ __("Start date") }}</label>
      <span>{{ data.StartFrom }}</span>
    </div>
    <div v-if="data.DurationDesc">
      <label>{{ __("Frequency") }}</label>
      <span>{{ data.DurationDesc }}</span>
    </div>
    <div v-if="data.Company">
      <label>{{ __("Name of supplier") }}</label>
      <span>{{ data.Company }}</span>
    </div>
  </div>
  <div v-if="data.Subject">
    <label>{{ __("Topic") }}</label>
    <span>{{ data.Subject }}</span>
  </div>
</template>

<script>
export default {
  props: {
    data: Object,
  },
};
</script>

<style scoped>

</style>
